export var SessionStorage;
(function (SessionStorage) {
    let TipPayment;
    (function (TipPayment) {
        function setPaymentInfo(source) {
            sessionStorage.setItem('tip_payment_finish_args', JSON.stringify(source));
        }
        TipPayment.setPaymentInfo = setPaymentInfo;
        function getPaymentInfo() {
            return JSON.parse(sessionStorage.getItem('tip_payment_finish_args') ?? '');
        }
        TipPayment.getPaymentInfo = getPaymentInfo;
    })(TipPayment = SessionStorage.TipPayment || (SessionStorage.TipPayment = {}));
})(SessionStorage || (SessionStorage = {}));
